import { z } from 'zod';

export const registrationStepFirstSchema = z.object({
    public_name: z
        .string()
        .trim()
        .min(1, 'Имя обязательно')
        .max(100, 'Имя слишком длинное')
        .regex(/^[^\p{Emoji}\p{Emoji_Component}]+$/u, "Эмодзи не разрешены")
        .regex(/^[\p{L}\s]+$/u, 'Разрешены только буквы и пробелы')
        .refine((val) => val.trim().length > 0, {
            message: 'Имя не может состоять только из пробелов',
        }),
    about_me: z
        .string()
        .trim()
        .min(1, 'Описание обязательно')
        .max(255, 'Максимальная длина описания - 255 символов'),
    //region: z.object({ label: z.string(), value: z.number() }).nullable(),
    regions: z.array(z.object({ label: z.string(), value: z.number() })).nullable(),
    gender: z.enum(['male', 'female'], { message: 'Пол обязателен' }).optional(),
    dob: z.string().min(1, { message: 'Дата обязательна' }),
    travel_plans: z.string().min(1, 'Поле не должно быть пустым').max(500, 'Описание слишком длинное'),
});

export type RegistrationStepFirstType = z.infer<typeof registrationStepFirstSchema>;
